import React from "react";
import { COLORS } from "shared/consts";
import {IconProps} from './index.tsx';

export const Hives: React.FC<IconProps> = ({
                                                fill = COLORS.FG.SOFT,
                                                width = 24,
                                                height = 24,
                                                className,
                                            }) => {
    return (
        <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
             width={width} height={height} fill="none">
            <rect id="24 / Special / Hive 2" width="24.000000" height="24.000000" x="0.000000" y="0.000000"/>
            <path id="Union"
                  d="M21 4.25C21 4.11193 20.8881 4 20.75 4L3.25 4C3.11193 4 3 4.11193 3 4.25L3 8.25C3 8.38807 3.11193 8.5 3.25 8.5L4 8.5L4 18C4 19.1046 4.89543 20 6 20L18 20C19.1046 20 20 19.1046 20 18L20 8.5L20.75 8.5C20.8881 8.5 21 8.38807 21 8.25L21 4.25ZM19.5 7L4.5 7L4.5 5.5L19.5 5.5L19.5 7ZM6 18.5C5.72386 18.5 5.5 18.2761 5.5 18L5.5 8.5L18.5 8.5L18.5 18C18.5 18.2761 18.2761 18.5 18 18.5L6 18.5ZM15 10.75C15 10.3358 14.6642 10 14.25 10L9.75 10C9.33579 10 9 10.3358 9 10.75C9 11.1642 9.33579 11.5 9.75 11.5L14.25 11.5C14.6642 11.5 15 11.1642 15 10.75Z"
                  fill={fill} fillRule="evenodd"/>
        </svg>
    );
};
